import { getAppAccessToken } from './appAccessToken';
import { getTokenFromUrl } from './getTokenFromURL';

export const getCurrentAuthToken = (inMemoryToken?: string | null): string | null =>
  getAppAccessToken() || inMemoryToken || sessionStorage.getItem('B2CToken') || getTokenFromUrl() || sessionStorage.getItem('token') || null;
